module.exports = __webpack_public_path__ + "img/whats.5bc77fe4.png";